// 非超级管理员访问增值功能时展示「增值功能待开通」
import React from 'react';
import { isSuperAdmin } from '../utils/auth';

const SuperOnlyRoute = ({ children }) => {
  if (isSuperAdmin()) return children;
  return (
    <div className="page-content">
      <div className="panel" style={{ textAlign: 'center', padding: '48px 24px' }}>
        <div className="panel-title" style={{ justifyContent: 'center', marginBottom: 8 }}>增值功能待开通</div>
        <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13 }}>该功能仅对超级管理员开放，如需开通请联系平台管理员。</div>
      </div>
    </div>
  );
};

export default SuperOnlyRoute;
